import { useState } from "react";
import { motion } from "framer-motion";
import { Copy, ThumbsUp, ThumbsDown, RotateCw, Check } from "lucide-react";
import AIAvatar from "./AIAvatar";
import MarkdownRenderer from "./MarkdownRenderer";
import ToolExecutionCard from "./ToolExecutionCard";
import TypingIndicator from "./TypingIndicator";

export default function MessageBubble({ message, onRegenerate }) {
  const [copied, setCopied] = useState(false);
  const [vote, setVote] = useState(null);
  const isAssistant = message.role === "assistant";

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(message.content || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch { /* ignore */ }
  };

  if (message.role === "user") {
    return (
      <motion.div
        className="ai-msg ai-msg-user"
        initial={{ opacity: 0, y: 6 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.22 }}
      >
        <div className="ai-msg-user-bubble">{message.content}</div>
      </motion.div>
    );
  }

  if (!isAssistant) return null;

  const showTyping = message.streaming && !(message.content || "").trim() && (!message.toolCalls || message.toolCalls.length === 0);

  return (
    <motion.div
      className="ai-msg ai-msg-asst"
      initial={{ opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.22 }}
    >
      <div className="ai-msg-asst-avatar">
        <AIAvatar size={28} />
      </div>
      <div className="ai-msg-asst-body">
        {(message.toolCalls || []).map((tc) => (
          <ToolExecutionCard key={tc.id || tc.name} tool={tc} />
        ))}
        {showTyping ? <TypingIndicator /> : null}
        {message.content ? <MarkdownRenderer text={message.content} /> : null}
        {!message.streaming && message.content ? (
          <div className="ai-msg-actions">
            <button type="button" className="ai-msg-action" onClick={copy} title="Copy">
              {copied ? <Check size={13} /> : <Copy size={13} />}
            </button>
            {onRegenerate ? (
              <button type="button" className="ai-msg-action" onClick={onRegenerate} title="Regenerate">
                <RotateCw size={13} />
              </button>
            ) : null}
            <button
              type="button"
              className={`ai-msg-action ${vote === "up" ? "is-on" : ""}`}
              onClick={() => setVote(vote === "up" ? null : "up")}
              title="Helpful"
            >
              <ThumbsUp size={13} />
            </button>
            <button
              type="button"
              className={`ai-msg-action ${vote === "down" ? "is-on" : ""}`}
              onClick={() => setVote(vote === "down" ? null : "down")}
              title="Not helpful"
            >
              <ThumbsDown size={13} />
            </button>
          </div>
        ) : null}
      </div>
    </motion.div>
  );
}
